import { render, staticRenderFns } from "./DateInputConfig.vue?vue&type=template&id=6b3f3650&"
import script from "./DateInputConfig.vue?vue&type=script&lang=js&"
export * from "./DateInputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports